import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class RoleService extends EntityService<IEntity> {
    constructor() {
        super(`/Roles`);
    }
}